var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCodeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,20H4c-1.1025391,0-2,0.8974609-2,2v6c0,1.1025391,0.8974609,2,2,2h6c1.1025391,0,2-0.8974609,2-2v-6 C12,20.8974609,11.1025391,20,10,20z M10,28H4v-6h6V28z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,12h6c1.1025391,0,2-0.8974609,2-2V4c0-1.1025391-0.8974609-2-2-2H4C2.8974609,2,2,2.8974609,2,4v6 C2,11.1025391,2.8974609,12,4,12z M4,4h6v6H4V4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,2h-6c-1.1025391,0-2,0.8974609-2,2v6c0,1.1025391,0.8974609,2,2,2h6c1.1025391,0,2-0.8974609,2-2V4 C30,2.8974609,29.1025391,2,28,2z M28,10h-6V4h6V10z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 6,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,12V8h-2v4h-3v2h3C17.1025391,14,18,13.1025391,18,12z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,14c-1.1025391,0-2,0.8974609-2,2v2h2v-2h2v-2H4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 18,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,14c-1.1025391,0-2,0.8974609-2,2v2h2v-2h4v-2H20z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 14,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,20v2h2c1.1025391,0,2-0.8974609,2-2v-2h-2v2H26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,20h-2v2c0,1.1025391,0.8974609,2,2,2h4v-2h-4V20z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,24c0,1.1025391,0.8974609,2,2,2h2v-2h-2v-4h-2V24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,30h2v-2h-2v-4h-2v4C26,29.1025391,26.8974609,30,28,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,30c1.1025391,0,2-0.8974609,2-2v-2h-2v2h-2v2H22z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 26,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28,
    width: 4,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeSmall);
export default __webpack_public_path__ + "static/media/qr-code--small.7f2a5f0f5127306ea317892018a23d5d.svg";
export { ForwardRef as ReactComponent };